// Packages
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { FormGroup } from "reactstrap";
import { getFromLocalStorage } from "../../utils/webStorage";
import moment from "moment";

// All Urls
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
import ElevationScroll from "./ElevationScroll";
import eventadded from "../../assets/images/eventadded.svg";
// import schoolAdminDashboard from "./schoolAdminPortal/schoolAdminDashboard"
// Styles
import "./schoolAdmin.css";

// Assets
import close from "../../assets/images/whitecross.png";
import backarrow from "../../assets/images/back-arrow.png";

// Material Ui
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import DialogTitle from "@material-ui/core/DialogTitle";
import Container from "@material-ui/core/Container";
import DialogContent from "@material-ui/core/DialogContent";
import CssBaseline from "@material-ui/core/CssBaseline";
import { validateForm } from "../../utils/validateFrom";
import { CircularProgress } from "@material-ui/core";
import { BsXLg } from "react-icons/bs";

import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// Services
import userService from "../../services/user.service";

import "bootstrap/dist/css/bootstrap.min.css";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../Validation/ValidationSchemas";
import { ERROR_MESSAGES, EVENT_TYPES, userRoles } from "../../utils/constant";
import * as Yup from "yup";
import { connect } from "react-redux";
import PageNotFound from "../../routes/PageNotFound";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
class AddSchoolCoaches extends React.Component {
  constructor(props) {
    super(props);
    this.myref = React.createRef();
    this.state = {
      fields: {},
      errors: {},
      countryList: [],
      schoolTypeList: [],
      teamsDropdownData: [],
      allSportsList: [],
      stateList: [],
      selectedCOuntry: "",
      countryId: null,
      stateid: "",

      eventName: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      country: "",
      state: "",
      schoolName: "",
      schoolType: "",
      sport: "",
      status: "",
      plan: "",
      anyMessage: "",
      specialty: "",
      selectedFile: null,
      fileAddress: null,
      uploadId: null,
      imagePreviewUrl: "",
      schoolId: null,
      team2Id: "",
      team1Id: getFromLocalStorage("schoolId"),
      eventDate: new Date(),
      eventTime: "",
      location: "",
      eventDescription: "",
      eventType: "",
      date: null,
      submitting: false,
      startDate: new Date(),
      hide: false,
      disableFlagEvent: false,
      disabled: false,
      newTeamName: "",
      schoolList: [],
      eventMatchTime: null,
      showFlag: false,
      setTime: new Date(),
      sportId: "",
      sportsList: [],
    };
    this.registerSchoolAdmin = this.registerSchoolAdmin.bind(this);

    this.dateChanged = this.dateChanged.bind(this);
    this.clear = this.clear.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date,
    });
  }

  onFormSubmit(e) {
    e.preventDefault();
  }

  dateChanged(d) {
    this.setState({ date: d });
  }

  clear() {
    this.setState({ date: null });
  }

  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }
  openDialogaddEvent() {
    this.setState({ openteam: !this.state.openteam });
  }
  closeDialogaddEvent() {
    this.setState({ openteam: !this.state.openteam });
  }
  componentDidMount() {
    const coach = document.getElementById("Event");
    if (coach) {
      coach.classList.add("btnActive");
    }
    const schoolId = getFromLocalStorage("schoolId");
    const eventDate = moment(this.state.eventDate).format("YYYY-MM-DD");
    let schoolName = getFromLocalStorage("schoolName");
    this.setState({ schoolId, eventDate, schoolName });
    this.getSchoolsDropdownData(schoolName);
    this.getTeamDropdownData(schoolId);
  }

  getSchoolsDropdownData(schoolName) {
    userService.getAllSchoolListing().then((res) => {
      var schoolList = [];
      schoolList = res.data.data.schools;
      const filteredSchoolList = schoolList.filter(function (item) {
        return item.schoolName !== schoolName;
      });
      this.setState({ schoolList: filteredSchoolList });
    }).catch = (err) => {
      console.error(err);
    };
  }

  getTeamDropdownData(id) {
    this.setState({
      submitting: true,
    });
    userService
      .getTeamsDropdown(id)
      .then((response) => {
        var teamsDropdownData = response.data.data.teams;
        this.setState({ teamsDropdownData });
        this.setState({
          submitting: false,
        });
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  handleRadioChange = (event) => {
    this.setState({ eventType: event.target.value });
    if (event.target.value == "Practices") {
      var disableFlagEvent = true;
      this.setState({ disableFlagEvent });
    } else {
      var disableFlagEvent = false;
      this.setState({ disableFlagEvent });
    }
  };

  ondateSet = (date) => {
    var dateSend = moment(date).format("YYYY-MM-DD");
    this.setState({
      eventDate: dateSend,
      startDate: date,
    });
    this.myref.current.setFieldValue("eventDate", dateSend);
    this.myref.current.setFieldError("eventDate", "");
  };

  registerSchoolAdmin({
    eventName,
    eventType,
    teamName,
    eventDate,
    eventTime,
    eventLocation,
    eventDescription,
    newTeamName,
  }) {
    const currentUserId = getFromLocalStorage("currentUserId");
    this.setState({ disabled: true });
    this.setEventTime(this.state.setTime);
    const { schoolId, showFlag } = this.state;

    userService
      .createEventAdd(
        eventDate,
        eventDescription,
        eventName,
        eventTime,
        eventLocation,
        schoolId,
        showFlag ? newTeamName : teamName,
        eventType,
        schoolId,
        newTeamName,
        currentUserId
      )
      .then((response) => {
        this.setState({ disabled: false });
        if (response.status === 200) {
          const eventId = response.data.data.id;
          const isOnPage = true;
          const pageName = "CELL";
          const type = "EVENT_ADDED";
          this.addEventActivity(
            eventId,
            schoolId,
            currentUserId,
            isOnPage,
            pageName,
            type
          );
          this.openDialogaddEvent();
          this.setState({
            submitting: false,
            hide: true,
            disabled: false,
          });
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          disabled: false,
        });
      });
  }

  addEventActivity = (eventId, schoolId, userId, isOnPage, pageName, type) => {
    userService.addActivityEventAdded(
      eventId,
      schoolId,
      userId,
      isOnPage,
      pageName,
      type
    );
  };

  setEventTime(time) {
    this.setState({ setTime: time });
    let result = time.toString().substring(16, 21);
    this.setState({ eventTime: result });
    this.myref.current.setFieldValue("eventTime", result);
    this.myref.current.setFieldError("eventTime", "");
  }

  setOtherTeamName(name) {
    this.setState({ team2Id: name });
  }

  checkTeamValue(e) {
    const showFlag = e.target.value == "null";
    this.setState({
      team2Id: e.target.value,
      showFlag,
    });
  }

  getAllsports = (schoolId) => {
    userService
      .getSports(schoolId)
      .then((response) => {
        if (response.data.status == true) {
          this.setState({
            sportsList: response.data.data,
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  render(props) {
    const {
      submitting,
      disableFlagEvent,
      disabled,
      open,
      openteam,
      schoolName,
      startDate,
      schoolList,
      showFlag,
      setTime,
    } = this.state;

    const { userRole } = this.props;

    return (
      <div>
        {userRole != userRoles.ROLE_ATHLETE ? (
          <Formik
            innerRef={this.myref}
            initialValues={{
              eventName: "",
              teamName: "",
              eventType: "",
              eventLocation: "",
              eventDescription: "",
              eventDate: "",
              eventTime: "",
              newTeamName: "",
            }}
            validationSchema={validationSchema.eventFormValidation}
            onSubmit={(values) => this.registerSchoolAdmin(values)}
          >
            {(formik) => (
              <Form>
                <div className={submitting ? "gray-out" : " "}>
                  <SchoolAdminDashboard />

                  <div className="content-layout add-sectionn p-0">
                    <>
                      <CssBaseline />
                      <ElevationScroll {...props}>
                        <div>
                          <Toolbar className="tb-p">
                            <div className="mng-header stickyy">
                              <div>
                                <Link to={this.props.location.state.path}>
                                  <span className="backbtn">
                                    <img src={backarrow} alt="back"></img>
                                  </span>
                                </Link>
                                <span className="txt-blue bold fs-18">
                                  CREATE EVENT
                                </span>
                              </div>

                              <div>
                                <button
                                  type="button"
                                  className="cancelbtn mr-2"
                                  onClick={this.openDialog.bind(this)}
                                >
                                  Cancel
                                </button>
                                <Dialog
                                  id="dialogBox"
                                  className="dialog-style"
                                  open={open}
                                  onClose={this.closeDialog.bind(this)}
                                >
                                  <DialogTitle>
                                    <div className="row">
                                      <div className="col-1 text-right ml-auto ">
                                        <BsXLg
                                          onClick={this.closeDialog.bind(this)}
                                          className="crossview cp"
                                        ></BsXLg>
                                      </div>
                                    </div>
                                  </DialogTitle>
                                  <DialogContent>
                                    <div className="clear10"></div>
                                    <div className="row">
                                      <div className="col-12 text-center">
                                        <p className="fs-20 semi-bold text-center mb-4">
                                          Are you sure you want to cancel?
                                        </p>
                                        <div className="clear10"></div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-right mr-3">
                                        <button
                                          type="button"
                                          class="cancelbtn"
                                          onClick={this.closeDialog.bind(this)}
                                        >
                                          No
                                        </button>
                                      </div>
                                      <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-left mr-3">
                                        <Link to="/schoolevents">
                                          <button type="button" class="yes-btn">
                                            Yes, Cancel
                                          </button>
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="clear10"></div>
                                    <div className="clear10"></div>
                                  </DialogContent>
                                </Dialog>

                                {/* create event pop up */}
                                <Dialog
                                  id="dialogBoxCreateEvent"
                                  className="dialog-style"
                                  open={openteam}
                                  onClose={this.closeDialogaddEvent.bind(this)}
                                >
                                  <DialogTitle>
                                    <div className="row">
                                      <div className="col-1 text-right ml-auto">
                                        <BsXLg
                                          onClick={this.closeDialogaddEvent.bind(
                                            this
                                          )}
                                          className="crossview cp"
                                        ></BsXLg>
                                      </div>
                                    </div>
                                  </DialogTitle>
                                  <DialogContent>
                                    <div className="clear10"></div>
                                    <div className="row">
                                      <div className="col-12 text-center">
                                        <p className="fs-20 semi-bold text-center mb-4">
                                          Are you sure you want to cancel?
                                        </p>
                                        <div className="clear10"></div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-right mr-3">
                                        <button
                                          type="button"
                                          class="cancelbtn"
                                          onClick={this.closeDialog.bind(this)}
                                        >
                                          No
                                        </button>
                                      </div>
                                      <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-left mr-3">
                                        <Link to="/schoolevents">
                                          <button type="button" class="yes-btn">
                                            Yes, Cancel
                                          </button>
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="clear10"></div>
                                    <div className="clear10"></div>
                                  </DialogContent>
                                </Dialog>

                                {/* create event pop up */}
                                <Dialog
                                  id="dialogBoxCreateEvent"
                                  className="dialog-style"
                                  open={openteam}
                                  onClose={this.closeDialogaddEvent.bind(this)}
                                >
                                  <DialogTitle>
                                    <div className="row">
                                      <div className="col-1 text-right ml-auto">
                                        <img
                                          onClick={this.closeDialogaddEvent.bind(
                                            this
                                          )}
                                          className="crossview cp"
                                          alt="close"
                                          src={close}
                                        ></img>
                                      </div>
                                    </div>
                                  </DialogTitle>
                                  <DialogContent>
                                    <div className="clear10"></div>
                                    <div className="row">
                                      <div className="col-12 text-center">
                                        <img
                                          src={eventadded}
                                          alt="success"
                                          className="successimg-new"
                                        ></img>
                                        <div className="clear10"></div>
                                        <p className="fs-20 semi-bold text-center mb-4">
                                          Event has been created successfully.
                                        </p>
                                        {/* <div className="clear10"></div> */}
                                      </div>
                                      <div className="col-12 col-md-12 col-lg-12 ml-auto text-center ">
                                        <Link to="/schoolEvents">
                                          <button
                                            type="button"
                                            class="donebtn"
                                            onClick={this.openDialogaddEvent.bind(
                                              this
                                            )}
                                          >
                                            Ok
                                          </button>
                                        </Link>
                                      </div>
                                    </div>

                                    <div className="clear10"></div>
                                  </DialogContent>
                                </Dialog>

                                {/* end */}
                                <button
                                  type="submit"
                                  className={
                                    disabled == false
                                      ? "saveBtn1"
                                      : "saveBtn1 activv"
                                  }
                                  disabled={disabled}
                                >
                                  Create
                                </button>
                              </div>
                            </div>
                          </Toolbar>
                        </div>
                      </ElevationScroll>
                      <div className="clear10"></div>
                      {submitting && (
                        <CircularProgress
                          style={{
                            width: "45px",
                            height: "44px",
                            position: "absolute",
                            left: "48%",
                            top: "47%",
                            zIndex: "99",
                          }}
                          color="secondary"
                        />
                      )}
                      <Container>
                        <form name="adminRegistrationForm">
                          <div className="col-lg-7 col-12 col-sm-12">
                            <div className="white-card">
                              <div className="row fs-18 ">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          Event Name{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.errors.eventName &&
                                            formik.touched.eventName &&
                                            "is-invalid"
                                          }`}
                                          type="text"
                                          name="eventName"
                                          id="eventName"
                                          placeholder="Enter Event Name"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.eventName &&
                                            formik.errors.eventName}
                                        </div>
                                      </FormGroup>
                                    </div>
                                    <div className="mt-12 col-md-12 col-lg-12">
                                      <div className="row">
                                        <div className="col-5 col-md-5 col-lg-5">
                                          <div class="form-group">
                                            <input
                                              className="instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect"
                                              name="specialty"
                                              value={schoolName}
                                              disabled
                                            />
                                          </div>
                                        </div>
                                        <div className="col-2 col-md-2 col-lg-2 text-center">
                                          <label className="fs-18 regular pt-3 vs-label">
                                            VS
                                          </label>
                                        </div>
                                        <div className="col-5 col-md-5 col-lg-5">
                                          <div class="form-group">
                                            <select
                                              className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect ${
                                                formik.errors.teamName &&
                                                "is-invalid"
                                              }`}
                                              name="teamName"
                                              onChange={(e) => {
                                                formik.setFieldValue(
                                                  "teamName",
                                                  e.target.value
                                                );
                                                if (e.target.value === "null") {
                                                  this.setState({
                                                    showFlag: true,
                                                  });
                                                } else {
                                                  this.setState({
                                                    showFlag: false,
                                                  });
                                                }
                                              }}
                                              disabled={disableFlagEvent}
                                            >
                                              <option value="">
                                                Select Team
                                              </option>
                                              {Array.isArray(schoolList) &&
                                              schoolList.length > 0
                                                ? schoolList.map(
                                                    (item, index) => {
                                                      return (
                                                        <option
                                                          key={index}
                                                          value={
                                                            item.schoolName
                                                          }
                                                        >
                                                          {item.schoolName}
                                                        </option>
                                                      );
                                                    }
                                                  )
                                                : null}
                                              <option value="null">
                                                Others
                                              </option>
                                            </select>
                                            <div className="errorMsg fs-14 medium">
                                              {formik.errors.teamName}
                                            </div>
                                            {showFlag && (
                                              <div className="">
                                                <Field
                                                  placeholder="Enter New Team"
                                                  type="text"
                                                  className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel newEvent ${
                                                    formik.errors.newTeamName &&
                                                    formik.touched
                                                      .newTeamName &&
                                                    "is-invalid"
                                                  }`}
                                                  name="newTeamName"
                                                />
                                                <div className="errorMsg fs-14 medium">
                                                  {formik.touched.newTeamName &&
                                                    formik.errors.newTeamName}
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          Event Type{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <div className="row width-100">
                                          <div
                                            role="group"
                                            aria-labelledby="my-radio-group"
                                            className="eventType"
                                          >
                                            <div className="row">
                                              {EVENT_TYPES.map(
                                                (item, index) => (
                                                  <div
                                                    className="col-4 col-md-4 col-lg-4"
                                                    key={index}
                                                  >
                                                    <label className="fmlabel mt-6 semi-bold">
                                                      <Field
                                                        type="radio"
                                                        name="eventType"
                                                        value={item}
                                                        checked={
                                                          formik.values
                                                            .eventType == item
                                                        }
                                                        className="mg-right-10"
                                                      />
                                                      {item}
                                                    </label>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </div>
                                          <div className="errorMsg fs-14 medium">
                                            {formik.errors.eventType}
                                          </div>
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold ">
                                          Event Date{" "}
                                          <span className="redstar">*</span>
                                        </label>

                                        <DatePicker
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel dateStyle cp ${
                                            formik.touched.eventDate &&
                                            formik.errors.eventDate &&
                                            "is-invalid"
                                          }`}
                                          selected={startDate}
                                          onChange={(date) =>
                                            this.ondateSet(date)
                                          }
                                          name="eventDate"
                                          dateFormat="MM/dd/yyyy"
                                          minDate={new Date()}
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.eventDate &&
                                            formik.errors.eventDate}
                                        </div>
                                      </FormGroup>
                                    </div>
                                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 pl-1">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold">
                                          Event Time{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                          style={{ border: "2px solid red" }}
                                        >
                                          <TimePicker
                                            className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel dateStyle cp ${
                                              formik.touched.eventTime &&
                                              formik.errors.eventTime &&
                                              "is-invalid"
                                            }`}
                                            label={false}
                                            value={setTime}
                                            onChange={(newValue) => {
                                              this.setEventTime(newValue);
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                fullWidth
                                              />
                                            )}
                                            InputProps={{
                                              disableUnderline: true,
                                            }}
                                          />
                                        </LocalizationProvider>
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.eventTime &&
                                            formik.errors.eventTime}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold">
                                          Location{" "}
                                          <span className="redstar">*</span>
                                        </label>
                                        <Field
                                          type="text"
                                          maxLength="50"
                                          className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.touched.eventLocation &&
                                            formik.errors.eventLocation &&
                                            "is-invalid"
                                          }`}
                                          name="eventLocation"
                                          placeholder="Enter Location"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.eventLocation &&
                                            formik.errors.eventLocation}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>

                                  <div className="clear10"></div>
                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <FormGroup>
                                        <label className="fmlabel mt-6 semi-bold">
                                          Event Description{" "}
                                          <span className="redstar">*</span>
                                        </label>

                                        <Field
                                          class={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                            formik.touched.eventDescription &&
                                            formik.errors.eventDescription &&
                                            "is-invalid"
                                          }`}
                                          rows="5"
                                          id="comment"
                                          maxLength="100"
                                          placeholder="Enter Description"
                                          disabled={disableFlagEvent}
                                          name="eventDescription"
                                        />
                                        <div className="errorMsg fs-14 medium">
                                          {formik.touched.eventDescription &&
                                            formik.errors.eventDescription}
                                        </div>
                                      </FormGroup>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="clear20"></div>
                          </div>
                        </form>
                        <div className="clear40"></div>
                      </Container>
                    </>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        ) : (
          <PageNotFoundPage />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRole: state.loggedInUser.role,
  };
};

export default withRouter(connect(mapStateToProps)(AddSchoolCoaches));
